// extracted by mini-css-extract-plugin
export default {"heading":"Elbows_heading__XQJvi","header":"Elbows_header__e7-8Z","subHeading":"Elbows_subHeading__fyeC6"};